import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class WorkStatus extends Mappeable {

    idTypeStatePk: number;
    stateJob: string;
    isActive: boolean;

    constructor(o) {
        super(o);
        this.isActive = this.isActive ??  false 
    }

    public mapToBack() {
        return {
            stateJob: this.stateJob,
            isActive: this.isActive,
        }
    }

}